import { render, staticRenderFns } from "./detail-itunes.vue?vue&type=template&id=be491e76&"
import script from "./detail-itunes.vue?vue&type=script&lang=js&"
export * from "./detail-itunes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports